<template>
  <section class="section section-alt">
    <Container>
      <div class="section-head">
        <p class="eyebrow" style="justify-content: center">Our Focus</p>
        <h2 class="section-title">What Drives Us</h2>
        <p class="section-subtitle">
          Six commitments that guide every batch of turkey berry powder and tea
          we craft, from farm to your table.
        </p>
      </div>

      <div class="aims-grid">
        <AimCard
          v-for="(item, index) in aimsList"
          :key="index"
          :icon="item.icon"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </Container>
  </section>
</template>

<script setup>
import { reactive } from 'vue'
import AimCard from './AimCard.vue'
import Container from "@/components/Container/Container.vue"


const aimsList = reactive([
  {
    icon: require('@/assets/core icons/recruitment.svg'),
    title: 'Promote Health and Wellness',
    description: 'Provide high-quality turkey berry powder and tea that enhance nutritional intake and support overall well-being.'
  },
  {
    icon: require('@/assets/core icons/employees.svg'),
    title: 'Educate Consumers',
    description: 'Raise awareness about the benefits of turkey berry and its role in traditional medicine and modern nutrition.'
  },
  {
    icon: require('@/assets/core icons/trainings.svg'),
    title: 'Sustainability',
    description: 'Implement eco-friendly practices throughout our production processes to minimize environmental impact.'
  },
  {
    icon: require('@/assets/core icons/sales.svg'),
    title: 'Support Local Communities',
    description: 'Collaborate with local farmers and producers, fostering economic growth and sustainable agriculture.'
  },
  {
    icon: require('@/assets/core icons/customer-service.svg'),
    title: 'Innovation',
    description: "Continuously develop new products and formulations that meet evolving consumer needs while maintaining the integrity of our ingredients."
  },
  {
    icon: require('@/assets/core icons/safety.svg'),
    title: "Quality Assurance",
    description: "Maintain the highest standards of quality and safety in our products to build trust and loyalty among consumers."
  },
])
</script>

<style scoped>
.aims-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.75rem;
}

@media (max-width: 1023px) {
  .aims-grid {
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 640px) {
  .aims-grid {
    grid-template-columns: 1fr;
  }
}
</style>
